export default __webpack_public_path__ + "static/media/Multi-client firm.38284d29.png";